module.exports = __webpack_public_path__ + "img/ViewNo.3ea7fc5e.svg";